import { dictionaryCRUD } from "../../../actions/dictionary"
import { selector } from "../../../api"
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { useEffect, useState } from "react"
import { toast } from "react-toastify"
import { Loading } from "../../constant";

const dictionaryItemSchema = Yup.object().shape({
  dictionary_item_name_en: Yup.string().required('English name is required'),
  dictionary_item_name_sw: Yup.string().required('Swahili name is required'),
  dictionary: Yup.string().required('Dictionary is required'),
})


export const EditDictionaryItem = (props) => {

  const { dataId, setIndex, index } = props

  const user = selector.User()
  const [loading, setLoading] = useState(false)
  const [dataLoading, setDataLoading] = useState(false)
  const [dictionaries, setDictionaries] = useState([])


  const initialValues = {
    dictionary_item_name_en: '',
    dictionary_item_name_sw: '',
    dictionary: '',
  }

  const formik = useFormik({
    initialValues,
    validationSchema: dictionaryItemSchema,
    onSubmit: (values, { setSubmitting }) => {
      const { dictionary_item_name_en, dictionary_item_name_sw, dictionary } = values
      const recorded_by = user.id
      const data = { dictionary_item_name_en, dictionary_item_name_sw, dictionary, recorded_by }
      setLoading(true)
      dictionaryCRUD.saveDictionaryItemChanges(dataId, data).then(() => {
        toast.success('Dictionary item has been updated.', { autoClose: 5000 })
        setIndex(index + 1)
        setSubmitting(false)
        setLoading(false)
      }).catch((error) => {
        toast.error('Failed to save changes', { autoClose: 5000 })
        setSubmitting(false)
        setLoading(false)
      })
    }
  })

  useEffect(() => {
    // Load all dictionaries for dropdown
    dictionaryCRUD.loadAllDictionary().then((resp) => {
      setDictionaries(resp.data)
    })
  }, [])

  useEffect(() => {
    if (!dataId) return;

    setDataLoading(true)
    dictionaryCRUD.loadDictionaryItemById(dataId).then((resp) => {
      formik.setFieldValue("dictionary_item_name_en", resp.data?.dictionary_item_name_en || '')
      formik.setFieldValue("dictionary_item_name_sw", resp.data?.dictionary_item_name_sw || '')
      formik.setFieldValue("dictionary", resp.data?.dictionary || '')
    }).finally(() => {
      setDataLoading(false)
    })
  }, [dataId])



  return (
    <>
      <div className="modal fade editItemModal" tabIndex="-1" role="dialog" aria-labelledby="editItemModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="editItemModalLabel">Edit Dictionary Item</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <hr />
            <form onSubmit={formik.handleSubmit}>
              {dataLoading ? <Loading /> :
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-6 col-sm-12">
                      <div className="mb-3">
                        <label className="form-label">English Name <span className="text-danger">*</span></label>
                        <input type="text" className="form-control" {...formik.getFieldProps('dictionary_item_name_en')} placeholder="English Name" />
                        {formik.touched.dictionary_item_name_en && formik.errors.dictionary_item_name_en && (
                          <div className='fw-light h6 mt-1' style={{ fontSize: '15px' }}>
                            <span role='alert' className='text-danger'>{formik.errors.dictionary_item_name_en}</span>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6 col-sm-12">
                      <div className="mb-3">
                        <label className="form-label">Swahili Name <span className="text-danger">*</span></label>
                        <input type="text" className="form-control" {...formik.getFieldProps('dictionary_item_name_sw')} placeholder="Swahili Name" />
                        {formik.touched.dictionary_item_name_sw && formik.errors.dictionary_item_name_sw && (
                          <div className='fw-light h6 mt-1' style={{ fontSize: '15px' }}>
                            <span role='alert' className='text-danger'>{formik.errors.dictionary_item_name_sw}</span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6 col-sm-12">
                      <div className="mb-3">
                        <label className="form-label">Dictionary <span className="text-danger">*</span></label>
                        <select className="form-select" {...formik.getFieldProps('dictionary')}>
                          <option value="">-- Select Dictionary --</option>
                          {dictionaries?.map((dt) => (
                            <option key={dt.id} value={dt.id}>{dt.dictionary_name_en || 'N/A'}</option>
                          ))}
                        </select>
                        {formik.touched.dictionary && formik.errors.dictionary && (
                          <div className='fw-light h6 mt-1' style={{ fontSize: '15px' }}>
                            <span role='alert' className='text-danger'>{formik.errors.dictionary}</span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              }
              <hr />
              <div className="modal-footer">
                <a href="javascript:void(0);" className="btn btn-soft-danger fw-medium" data-bs-dismiss="modal"><i className="ri-close-line me-1 align-middle"></i> Close</a>
                <button type='submit' className="btn btn-soft-success" disabled={formik.isSubmitting || loading}>
                  {!loading && <span className='indicator-label'><i className="las la-save la-lg"></i>save </span>}
                  {loading && (
                    <span className='indicator-progress' style={{ display: 'block' }}>
                      Please wait...
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  )

}
